import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollManager() {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    let rafId: number;

    const restoreScroll = (target: number, attempts = 0) => {
      const pageIsReady = document.documentElement.scrollHeight > target + window.innerHeight;
      if (pageIsReady || attempts >= 20) {
        window.scrollTo({ top: target, behavior: 'instant' as ScrollBehavior });
      } else {
        rafId = requestAnimationFrame(() => restoreScroll(target, attempts + 1));
      }
    };

    if (navType === 'POP') {
      const saved = sessionStorage.getItem(`scroll:${location.key}`);
      if (saved) {
        restoreScroll(parseInt(saved, 10));
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    }

    return () => {
      cancelAnimationFrame(rafId);
      sessionStorage.setItem(`scroll:${location.key}`, String(window.scrollY));
    };
  }, [location.key, navType]);

  return null;
}
